/**
 * number-format
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2017 Mediatel Limited.
 */

"use strict";

export default function numberFormat(number, decimals) {
    if(Number.isNaN(number)) {
        return number;
    }

    return Number(number)
        .toLocaleString('en-GB', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
};